import { getHooksForCompany } from '../store/apis/helper/apiHelpers';
import { formatDateToISO } from '../utilities/dateUtils'; 

const useFetchFinancialData = (selectedCompany, startDate, endDate) => {
    if (!selectedCompany) {
        return { data: null, isLoading: true, error: 'no Company' };  
    }

    const apiHooks = getHooksForCompany(selectedCompany);
    if (!apiHooks) {
        return { data: null, isLoading: false, error: 'API hooks not found' };
    }
    
    const formattedStartDate = formatDateToISO(new Date(startDate));
    const formattedEndDate = formatDateToISO(new Date(endDate));
    const lastYearStartDate = formatDateToISO(new Date(new Date(startDate).setFullYear(new Date(startDate).getFullYear() - 1)));
    const lastYearEndDate = formatDateToISO(new Date(new Date(endDate).setFullYear(new Date(endDate).getFullYear() - 1)));

    const balanceQuery = apiHooks.useFetchBalanceQuery({ from: formattedStartDate, to: formattedEndDate });
    const budgetQuery = apiHooks.useFetchBudgetQuery({ from: formattedStartDate, to: formattedEndDate, budgetGroup:"Budget" });
    const lastYearBalanceQuery = apiHooks.useFetchLastYearBalanceQuery({ from: lastYearStartDate, to: lastYearEndDate });

    const isLoading = balanceQuery.isLoading || budgetQuery.isLoading || lastYearBalanceQuery.isLoading;

    const errors = [];
    if (balanceQuery.error) errors.push('Balance data could not be fetched');
    if (budgetQuery.error) errors.push('Budget data not available or could not be fetched');
    if (lastYearBalanceQuery.error) errors.push('Last year balance data could not be fetched');


    const formattedData = !isLoading ? {
        balanceData: balanceQuery.data || [], 
        budgetData: budgetQuery.data || [],
        lastYearBalanceData: lastYearBalanceQuery.data || []
    } : null;


    const error = errors.length > 0 ? errors.join('. ') : null;

    return { data: formattedData, isLoading, error };
};

export default useFetchFinancialData;



